import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import propTypes from 'prop-types';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';
import accImg from './acc_icon.png';
import errImg from './error-cone.png';
import preloadImg from '../../lib/util/preload-img';
import { LOG_IN_ROUTE } from '../../constants/constants';

preloadImg(accImg);
preloadImg(errImg);

class Confirmation extends React.Component {
	componentDidMount () {
		if (_.isEmpty(this.props.inspectionRequest)) {
			this.props.setRoute(LOG_IN_ROUTE);
		} else {
			this.props.setParentState({
				progressIndex: -1,
				canLogOut: false,
				canGoToHomePage: true
			});
		}
	}

	render () {
		// Dispite changing the route in componentDidMount React will attempt to render this
		// at least once, so we're doing this to avoid a crash
		if (_.isEmpty(this.props.inspectionRequest)) {
			return (<div />);
		}

		const __ = mergeI18n(this.props.language, i18n);

		const success = this.props.scheduleSucceeded;
		document.title = `${__.titleStem} - ${__.pageTitle}`;

		const confirmationIcon = (
			<img src={accImg} alt='' />
		);

		const errorCone = (
			<img className='error-cone' src={errImg} alt='' />
		);

		return (
			<div id='confirmation' className={classnames({ 'row': true, 'success': success })}>
				<div className='col-xs-12 col-centered text-center'>
					{success ? confirmationIcon : errorCone}
					<h1 className={classnames({ 'error': !success })}>{__.appointmentStatus(success, this.props.usingClick)}</h1>
					<h2>{__.confirmationNo(success, this.props.inspectionRequest.confirmationNo)}</h2>
					<div className='directions'>
						<p>{__.thankYou(success, this.props.usingClick)}</p>
						<p>{__.youWillReceiveEmail(success, this.props.contact.email)}</p>
					</div>
					{success ?
						(<p className='hint'>{__.youCanCloseThisWindow}</p>) :
						(<form action='/log-in'>
							<button type='submit' className='btn btn-primary'>{__.startOver}</button>
						</form>)}
				</div>
			</div>
		);
	}
}

Confirmation.propTypes = {
	inspectionRequest: propTypes.shape({
		confirmationNo: propTypes.number
	}).isRequired,
	contact: propTypes.shape({
		phone: propTypes.string.isRequired,
		email: propTypes.string.isRequired,
		prefContactMethod: propTypes.string.isRequired
	}).isRequired,
	language: propTypes.string.isRequired,
	scheduleSucceeded: propTypes.bool.isRequired,
	usingClick: propTypes.bool.isRequired,
	setParentState: propTypes.func.isRequired,
	setRoute: propTypes.func.isRequired
};
export default Confirmation;
